import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { dateTime } from "@/shared/utills/date";
import { CUSTOMER } from "@/shared/resource/apis/endpoints";
import { CUSTOMER_INFORMATION, CUSTOMER_DETAIL_INFORMATION } from "@/shared/resource/constants";

export const useCustomerStore = defineStore("customer", {
  state: () => ({
    customers:{
      list : [],
      totalCount : 0,
      info :  [...CUSTOMER_INFORMATION],
    },
    customer : {
      data : null,
      info : [...CUSTOMER_DETAIL_INFORMATION],
    }
  }),

  actions: {
    resetCustomerData() {
      this.customers.list = []
      this.customers.totalCount = 0;
    },

    async fetchCustomers({ page = 1, limit = 10, filters = {} }) {
      this.resetCustomerData();

      const response = await api.get(CUSTOMER.LIST, { params: { page_no: page, limit, ...filters }});
      const data = response?.data?.data || [];

      const formattedEntities = data.map((item) => ({
        uuid: item.id,
        id: item.customer_id,
        name: item.name || "-",
        createdAt: dateTime.formatDateTime(item.created_at),
        phoneNumber: item.phone_number,
        email: item.email || "-",
        bookings: item.bookingCount,
        revenue: item.total_revenue,
        cancellations: item.cancelledBooking,
        wallet: item.wallet_balance,
        status: item.is_active,
      }));

      this.setCustomersData(formattedEntities, response?.data?.total_entries || 0, response?.data?.stats);
      return formattedEntities;
    },

    setCustomersData(customers, totalCount, info) {
      this.customers.list = customers || [];
      this.customers.totalCount = totalCount || 0;
      if(info){
        const { total_customers = 0, new_users_in_30_days = 0, activeUsersCount = 0 } = info;
        this.customers.info[0].count = total_customers;
        this.customers.info[1].count = new_users_in_30_days;
        this.customers.info[2].count = activeUsersCount;
      } 
    },

    setCustomerInformation(stats) {
      const { totalBookings, cancelledBooking, search_count, total_revenue, referral_count } = stats?.data;

      this.customer.info[0].value = total_revenue || 0;
      this.customer.info[1].value = totalBookings || 0;
      this.customer.info[2].value = cancelledBooking || 0;
      this.customer.info[3].value = referral_count || 0;
      this.customer.info[4].value = search_count || 0;
    },

    async getCustomerDetails(id, info = false) {
      if (!id) return;

      const response = await api.get(CUSTOMER.GET(id));
      if (info) this.setCustomerInformation(response.data);
      this.customer.data = response?.data?.data || null
      return response?.data;
    },

    async updateCustomer(id, payload) {
      const response = await api.put(CUSTOMER.UPDATE(id), payload);
      return response.data;
    },
  },

  getters: {
    getCustomers : (state) => state.customers,
    getCustomer : (state) => state.customer,
  },
});
